import React from 'react';
import { Line } from 'react-chartjs-2';
import useWindowDimensions from "common/hook/useWindowDimensions";
import './Graph.css'

function PricingModel({
  yAxisCoordinate
}) {
  let pointBackgroundColors = new Array(15).fill('');
  let pointRadius = new Array(15).fill(0);
  
  let data = [null,570, 400, 270, 192, 149, 126, 113, 104, 97.5, 92, 88.5, 86,85];
  let data2 = [null,570, 400, 270, 192, 149, 126, 113, 104, 97.5, 92, 88.5, 86,85];

  const { width } = useWindowDimensions();

  let responsiveBorderWidth;
  let responsivePointRadiusSize;
  if( width <= 520) {
    responsiveBorderWidth = 5;
    responsivePointRadiusSize = 2.5;
  } else if (width >= 520 && width <= 689) {
    responsiveBorderWidth = 5;
    responsivePointRadiusSize= 3;
  } else if (width >= 689 && width <= 875){
    responsiveBorderWidth = 10;
    responsivePointRadiusSize= 4;
  }
  else if (width >= 875) {
    responsiveBorderWidth = 12;
    responsivePointRadiusSize= 4;
  } 

  const chartData = {
    labels: ["0", '1', '2', "3", "4", "5", "6", "7",'8','9','10','11','12','13'],
    datasets: [
      {
        label:'before',
        fill: false,
        borderColor: '#48A6E0',
        borderWidth: responsiveBorderWidth,
        borderCapStyle:'round',
        pointBackgroundColor: pointBackgroundColors,
        pointRadius: pointRadius,
        data:  data     
      },
      {
        label:'after',
        fill: false,
        borderColor: 'white',
        borderWidth: responsiveBorderWidth,
        borderCapStyle:'round',
        pointBackgroundColor: pointBackgroundColors,
        pointRadius: pointRadius,
        data: data2,
      },
    ],
  }
  const options={
    events: [],
    responsive: true,
    scales: {
      xAxes: [
        {
          ticks: {
            display: true, 
            fontColor:"transparent", 
          },
          gridLines: {
            color: "#FFFFFF", 
            lineWidth:0.7, 
            drawOnChartArea :true, 
            drawTicks: false,
          }
          
        }],
      yAxes: [
        {
          ticks: {
            display: true, 
            fontColor:"transparent",
            min: 50,
            max: 580,
            stepSize:100,
          },
          gridLines: {
            color: "#FFFFFF", 
            lineWidth:0.7, 
            drawOnChartArea :true, 
            drawTicks: false,
          }
        }],
    },
    legend: {
      display: false
    },
    animation: {
      duration: 0
    },
  }

  let coordinates = chartData.datasets[1].data;

  for (let idx = 0; idx <coordinates.length; idx++) {
    let coordinate = coordinates[idx]
    if ( coordinate === yAxisCoordinate) {
      // current point
      pointBackgroundColors[idx] = "#48A6E0";
      pointRadius[idx] = responsivePointRadiusSize;

      // shades used METs-  blue
      for(let i = data.length - 1; i > idx; i--) {
        data[i] = null;
      };

      // shades unused METs - white
      for(let j = 0; j < idx; j++) {
        data2[j] = null;
      };
    } 
  }

  
  return (
    <div className="react-graph-wrapper">
        <div className="react-container">
          {/* <div className="react-graph-title">Striim Events</div> */}
          <div className="react-graph-row">
            <div className="react-graph-yaxis"> Cost per million events</div>
            <Line data={chartData} width={730} height={385} options={options}/>
          </div>
          <div className="react-graph-title">Striim Events</div>
          <div className="react-graph-button-wrapper">
            <a href="https://go2.striim.com/request-pricing-plan" className="react-graph-request-link">
              <span className="react-graph-button-text">Request Plan</span>
            </a>
          </div>
        </div>
    </div>
  );
}

export default PricingModel;
